import { AsyncPipe } from "@angular/common";
import { Component, inject } from "@angular/core";
import { NgIcon, provideIcons } from "@ng-icons/core";
import { heroBookOpen, heroChevronRight, heroEnvelope, heroFilm, heroSparkles } from "@ng-icons/heroicons/outline";
import { showSpace, trackEvent, update as intercomUpdate } from "@intercom/messenger-js-sdk";

import { EvaDrawerComponent } from "../eva-drawer/eva-drawer.component";
import { EvaHelpService } from "./eva-help.service";

/**
 * EvaHelpDrawerComponent — Drawer "Centre d'aide" global.
 *
 * Une seule instance doit être déclarée dans le layout principal (eva-layout).
 * Sa visibilité est pilotée par EvaHelpService.
 */
@Component({
  selector: "eva-help-drawer",
  standalone: true,
  imports: [AsyncPipe, EvaDrawerComponent, NgIcon],
  templateUrl: "./eva-help-drawer.component.html",
  styleUrls: ["./eva-help-drawer.component.scss"],
  viewProviders: [
    provideIcons({
      heroBookOpen,
      heroChevronRight,
      heroEnvelope,
      heroFilm,
      heroSparkles,
    }),
  ],
})
export class EvaHelpDrawerComponent {
  readonly helpService = inject(EvaHelpService);

  onVisibleChange(visible: boolean): void {
    this.helpService.setVisible(visible);
  }

  openDocumentation(): void {
    trackEvent("help-center-click", { item: "documentation" });
    showSpace("help");
    this.helpService.close();
  }

  trackVideosClick(): void {
    trackEvent("help-center-click", { item: "videos" });
  }

  trackNewsClick(): void {
    trackEvent("help-center-click", { item: "news" });
  }

  openSupport(): void {
    trackEvent("help-center-click", { item: "support" });
    intercomUpdate({ hide_default_launcher: false });
    showSpace("home");
    this.helpService.close();
  }
}
